/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AllocationDimensionTarget extends models.AllocationTarget {
    constructor() {
        super();
        this.setDiscriminator("AllocationDimensionTarget");
    }

    getFixupPrototypeFunction() { return AllocationDimensionTarget.fixupPrototype; }

    static newInstance(model: Partial<AllocationDimensionTarget>): AllocationDimensionTarget {
        let obj = Object.assign(new AllocationDimensionTarget(), model);
        AllocationDimensionTarget.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AllocationDimensionTarget>): AllocationDimensionTarget {
        if (!model) return null;
        return AllocationDimensionTarget.newInstance(<AllocationDimensionTarget> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AllocationDimensionTarget) {
        if (!obj) return;

        models.AllocationDimensionTarget.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AllocationDimensionTarget): boolean {
        if (models.AllocationTarget.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AllocationDimensionTarget.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    tenant_id: string;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    dimension_id: string;

    dimension_name: string;

}
